"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  prepare: val => ({
    title: String(val)
  })
};
exports.default = _default;